import { QueryClient } from '@tanstack/react-query'
import { ApiError } from './api'

/**
 * The one query cache for the app. It lives here rather than in App.tsx so
 * the auth layer can empty it: every cached list belongs to whoever was
 * signed in when it was fetched, and must not survive into the next
 * person's session (or an impersonation) — not even for the 15 seconds it
 * would otherwise be considered fresh.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 15_000,
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        // Retrying an auth or permission failure only produces the same
        // answer more slowly.
        if (error instanceof ApiError && (error.isAuth || error.isForbidden || error.isNotFound)) {
          return false
        }
        return failureCount < 2
      },
    },
  },
})
